import { Icon, TextHtml } from 'ui';
import ItemComplexList from 'core/modules/components/general/ItemComplexList';
import AssessmentGradeTag from 'core/modules/compositions/AssessmentGradeTag';
import AssessmentStatusTags from 'core/modules/compositions/AssessmentStatusTags';
import { getContentLang } from 'core/utils/contentLang';
import { getDueDate } from 'core/utils/date';
import { CONTENT_TYPES, typeContentsIcons } from 'core/variables/constant';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';

const AssessmentItem = ({
  t,
  course,
  lessonName,
  title,
  dueDate,
  questionsLength,
  status,
  type,
  grade,
  gradeTotal,
  lesson_item_content_is_evaluable,
  lesson_item_content_type_guid,
  consumed_at,
  data,
}) => {
  const [dueTaskSettings, setDueTaskSettings] = useState({});
  const contentLang = getContentLang(course);

  const FILTER = {
    'assessment-assigned': 'to-do',
    'assessment-reassigned': 'to-do',
    'assessment-evaluated': 'to-do',
    'resource-assigned': 'to-do',
    'resource-delivered': 'turned-in',
    'one-day': 'to-do',
    late: 'to-do',
    assigned: 'to-do',
    soon: 'to-do',
    'turned-in': 'turned-in',
    'turned-in-late': 'turned-in',
    'timed-out': 'turned-in',
  };
  useEffect(() => {
    setDueTaskSettings(getDueDate(dueDate, status));
  }, []);

  function renderTopLeftInfo() {
    return (
      <div className="assessment-item__header">
        <span className="assessment-item__course">{course.education_discipline_name || data.course.discipline_name}</span>
        <span>
          <TextHtml className="assessment-item__lesson" lang={contentLang} text={lessonName} />{' '}
        </span>
      </div>
    );
  }

  function renderBottomLeftInfo() {
    return (
      <div className="assessment-item__left">
        <div
          className={`assessment-item__filter-icon assessment-item__filter-icon--${
            (FILTER[status] === 'to-do' && grade === null) || consumed_at ? 'to-do' : ''
          } `}
        >
          <Icon
            name={lesson_item_content_is_evaluable ? 'task2' : typeContentsIcons[type]}
            color={(FILTER[status] === 'to-do' && grade === null) || consumed_at ? 'primary' : 'label'}
          />
        </div>
        <div className="assessment-item__info">
          {questionsLength && type !== 'test' && (
            <span className="assessment-item__questions-length">{t('lesson:X questions', { count: questionsLength })} </span>
          )}

          <span className="assessment-item__title" title={title}>
            {lesson_item_content_type_guid === CONTENT_TYPES.MINT ? t('assigments:Activity') + ' ' : ''}
            <span lang={contentLang}>{title}</span>
          </span>
          <div className="assessment-item__date-container">
            <div className="assessment-item__date-icon">
              <Icon name="calendar" color={dueTaskSettings.style === 'late' ? 'primary' : 'label'} />
            </div>
            <div className="assessment-item__date">
              <>{<>{t(`lesson:${dueTaskSettings.string}`, { date: dueTaskSettings.dateDinamic })} </>}</>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderBottomRightInfo() {
    return (
      <div className="assessment-item__right">
        {status === 'assessment-evaluated' || status === 'resource-evaluated' ? (
          <AssessmentGradeTag grade={grade} gradeTotal={gradeTotal} />
        ) : (
          status && <AssessmentStatusTags status={status} size="big" />
        )}
      </div>
    );
  }

  return (
    <div className={`assessment-item task-pending-item assessment-item--status-${dueTaskSettings.style}`}>
      <ItemComplexList center={renderTopLeftInfo()} />
      <ItemComplexList center={renderBottomLeftInfo()} right={renderBottomRightInfo()} />
    </div>
  );
};

AssessmentItem.propTypes = {
  t: PropTypes.func,
  course: PropTypes.object,
  lessonName: PropTypes.string,
  title: PropTypes.string,
  dueDate: PropTypes.string,
  questionsLength: PropTypes.number,
  status: PropTypes.string,
  type: PropTypes.string,
  grade: PropTypes.string,
  gradeTotal: PropTypes.string,
  lesson_item_content_is_evaluable: PropTypes.bool,
  lesson_item_content_type_guid: PropTypes.string,
  consumed_at: PropTypes.string,
  data: PropTypes.object,
};

AssessmentItem.defaultProps = {
  course: {},
  lessonName: 'Lesson Name',
  questionsLength: 10,
  status: 'late',
  title: 'This is a title',
  type: 'questionary',
};

export default withTranslation(['common', 'lesson'])(AssessmentItem);
